package web.fstech.onthecoffee

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import kotlinx.browser.window
import org.w3c.dom.events.Event
import web.fstech.onthecoffee.app.AppIntent
import web.fstech.onthecoffee.app.AppRoute
import web.fstech.onthecoffee.app.AppViewModel
import web.fstech.onthecoffee.privacy.AppLanguage
import kotlin.js.ExperimentalWasmJsInterop

@OptIn(ExperimentalWasmJsInterop::class)
@Composable
fun App(
    viewModel: AppViewModel = remember { AppViewModel() }
) {
    val state by viewModel.uiState.collectAsState()

    MaterialTheme {
        DisposableEffect(Unit) {
            val listener: (Event) -> Unit = {
                viewModel.processIntent(AppIntent.SyncFromWindowLocation)
            }
            window.addEventListener("popstate", listener)
            window.addEventListener("hashchange", listener)
            onDispose {
                window.removeEventListener("popstate", listener)
                window.removeEventListener("hashchange", listener)
            }
        }

        val onNavigate: (String) -> Unit = { routeName ->
            viewModel.processIntent(AppIntent.NavigateTo(routeName))
        }

        val onLanguageChange: (AppLanguage) -> Unit = { language ->
            viewModel.processIntent(AppIntent.ChangeLanguage(language))
        }

        when (state.currentRoute) {
            AppRoute.PRIVACY -> PrivacyPolicyPage(
                onBack = { onNavigate("home") },
                language = state.language,
                onLanguageChange = onLanguageChange
            )
            AppRoute.SIGN_IN, AppRoute.SIGN_UP, AppRoute.FORGOT, AppRoute.DELETE -> AuthPortalPage(
                onBack = { onNavigate("home") },
                initialRoute = state.currentRoute.routeName,
                onNavigate = onNavigate,
                language = state.language,
                onLanguageChange = onLanguageChange
            )
            AppRoute.HOME -> LandingPage(
                onNavigate = onNavigate,
                language = state.language,
                onLanguageChange = onLanguageChange
            )
        }
    }
}
